export type CabinetNavId = "services" | "publish" | "billing" | "company" | "profile" | "partner";

export type CabinetNavItem = {
    id: CabinetNavId;
    href: string;
    label: string;
    tabLabel: string;
    hint: string;
    partnerOnly?: boolean;
};

export const CABINET_NAV: CabinetNavItem[] = [
    { id: "services", href: "/cabinet", label: "Сервисы", tabLabel: "Сервисы", hint: "Mini App и CRM" },
    {
        id: "publish",
        href: "/cabinet/publish",
        label: "Каталог",
        tabLabel: "Каталог",
        hint: "Кейс и юр. документы",
    },
    { id: "billing", href: "/cabinet/billing", label: "Счета и оплата", tabLabel: "Счета", hint: "Тарифы, модули, ★" },
    { id: "company", href: "/cabinet/company", label: "Реквизиты", tabLabel: "Реквизиты", hint: "Для договоров" },
    { id: "profile", href: "/cabinet/profile", label: "Профиль", tabLabel: "Профиль", hint: "Контакты и вход" },
    { id: "partner", href: "/cabinet/partner", label: "Партнёрам", tabLabel: "Партнёры", hint: "Рефералы и промокоды", partnerOnly: true },
];

export function cabinetSectionFromPath(pathname: string): CabinetNavId {
    if (pathname.startsWith("/cabinet/notifications")) return "services";
    if (pathname.startsWith("/cabinet/publish")) return "publish";
    if (pathname.startsWith("/cabinet/billing")) return "billing";
    if (pathname.startsWith("/cabinet/company")) return "company";
    if (pathname.startsWith("/cabinet/profile")) return "profile";
    if (pathname.startsWith("/cabinet/partner")) return "partner";
    return "services";
}

export function cabinetPageTitle(pathname: string): string {
    if (pathname.startsWith("/cabinet/create")) return "Новый сервис";
    if (pathname.startsWith("/cabinet/notifications")) return "Мои уведомления";
    switch (cabinetSectionFromPath(pathname)) {
        case "publish":
            return "Каталог";
        case "billing":
            return "Счета и оплата";
        case "company":
            return "Реквизиты";
        case "profile":
            return "Профиль";
        case "partner":
            return "Партнёрам";
        default:
            return "Сервисы";
    }
}
